import nodeApi from '../utils/nodeApiClient';

const usersApi = {
  list: () => nodeApi.get('/users'),
  getById: (id) => nodeApi.get(`/users/${id}`),
  create: (data) => nodeApi.post('/users', data),
  update: (id, data) => nodeApi.put(`/users/${id}`, data),
  remove: (id) => nodeApi.delete(`/users/${id}`)
};

export default usersApi;
